import {Model} from "@bryntum/schedulerpro";

export class ResourceAgenda extends Model {
  static get $name() {
    return "ResourceAgenda";
  }

  static get fields() {
    return [
      { name: "isAgendaEnabled", dataSource: "is_enabled", type: "boolean" },
      { name: "passCode", dataSource: "password" },
      { name: "slug" },
      { name: "url" },
      { name: "isEntitySharing", dataSource: "is_entity_detail_sharing_allowed" }
    ]
  }
}

ResourceAgenda.exposeProperties();